import { render, staticRenderFns } from "./GCreateNewEmployee.vue?vue&type=template&id=6dfffe9a&scoped=true&"
import script from "./GCreateNewEmployee.vue?vue&type=script&lang=ts&"
export * from "./GCreateNewEmployee.vue?vue&type=script&lang=ts&"
import style0 from "./GCreateNewEmployee.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfffe9a",
  null
  
)

export default component.exports